export default function determineSide(side) {
  switch (side) {
    case 'buy':
    case 'buy_to_open':
      return 'BTO';
    case 'sell_short':
    case 'sell_to_open':
      return 'STO';
    case 'buy_to_cover':
    case 'buy_to_close':
      return 'BTC';
    case 'sell_to_close':
    case 'sell':
      return 'STC';
    default: 
      return 'Unknown'
  }
}
